import React from 'react';
import { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import Header from '../../components/header';
import Footer from '../../components/footer';
import Head from '../../components/head';
import Obrigatorias from '../../components/transferenciasestado/obrigatorias';


function ObrigatoriasScreen() {
    return (
        <Fragment>
            <Head titulo="Transferências Estaduais Obrigatórias" />
            <Header />
            <Container>
                <Obrigatorias />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ObrigatoriasScreen;